import React, { useEffect } from 'react'
import { SBText } from 'components/styledComponents/text'

const AppInMaintenance = (props) => {
  
  return (
    <div className="text-center">
        { props.maintenanceTitle && props.maintenanceTitle != "" &&
            <SBText size={2}>Title goes here, If any</SBText>
        }
        { props.maintenanceMessage && props.maintenanceMessage != "" &&
            <p className="mt-4 fw">
                <strong>
                {props.maintenanceMessage}
                </strong>
            </p>
        }
        {/* Default maintenance message in case the message is not supplied from backend */}
        { !props.maintenanceMessage &&
            <p className="mt-4 fw">
                <strong>
                The application is unavailable for scheduled maintenance. We apologise for any inconvenience.
                </strong>
            </p>
        }
      
    </div>
  )
}

export default AppInMaintenance
